import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPathPaused = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M21.668 20.3L1.96797 0.5L0.667969 1.8L6.46797 7.6L1.56797 8L7.06797 12.8L5.46797 19.8L11.668 16.1L17.868 19.8L17.568 18.6L20.468 21.5L21.668 20.3ZM15.368 16.5L11.568 14.2L7.76797 16.5L8.76797 12.2L5.46797 9.3L7.96797 9.1L15.368 16.5ZM10.768 6.8L9.56797 5.6L11.568 0.8L14.368 7.4L21.568 8L16.468 12.4L15.368 11.3L17.768 9.3L13.368 8.9L11.668 4.9L10.768 6.8Z",
		fill: "#90A4AE"
	})]
});
const ForwardRef = forwardRef(SvgPathPaused);
export { ForwardRef as ReactComponent };
